import { FeatureFlagModel } from "../../../models/feature-flags-model";

export interface FeatureFlagAdopterHubState {
  initialState: boolean;
  featureFlagAdopterHub: FeatureFlagModel | null;
}

export const featureFlagAdopterHubInitialState: FeatureFlagAdopterHubState = {
  initialState: true,
  featureFlagAdopterHub: null
};
